/**
 * Exibe o texto
 * @param $element
 *  jquery element
 * @param noAnimation
 *  se deve remover a animação da altura
 * @private
 */
function show($element, noAnimation) {
    let maxHeight = $element.data('max-height');

    if (noAnimation) {
        $element.removeAttr('style');
        $element.next('a[data-toggle="text-collapse"]').find('i').removeClass('fa-rotate-180');
        $element.data('collapsed', false);
    } else {
        $element.attr('style', 'height: ' + $element.outerHeight() + 'px;');
        $element.next('a[data-toggle="text-collapse"]').find('i').removeClass('fa-rotate-180');
        $element.stop().animate({ height: maxHeight }, 750, function () {
            // Animation complete.
            $element.css('height', '');
            $element.data('collapsed', false);
        });
    }
}

/**
 * Esconde o texto
 * @param $element
 *  jquery element
 * @param noAnimation
 *  se deve remover a animação da altura
 * @private
 */
function hide($element, noAnimation) {
    let lineHeight = parseFloat($element.css('line-height'));
    let minHeight = $element.data('lines') * lineHeight;
    let maxHeight = $element.outerHeight();

    $element.data('min-height', minHeight);
    $element.data('max-height', maxHeight);

    if (noAnimation) {
        $clamp($element.get(0), {
            clamp: $element.data('lines')
        });
        $element.next('a[data-toggle="text-collapse"]').find('i').addClass('fa-rotate-180');
        $element.data('collapsed', true);
    } else {
        $element.attr('style', 'height: ' + maxHeight + 'px;');
        $element.next('a[data-toggle="text-collapse"]').find('i').addClass('fa-rotate-180');
        $element.stop().animate({ height: minHeight }, 750, function () {
            // Animation complete.
            $clamp($element.get(0), {
                clamp: $element.data('lines')
            });
            $element.data('collapsed', true);
        });
    }
}

function init() {
    $('.text-collapse').each(function () {
        let $element = $(this);
        let $btnToggle = $('<a href="javascript:void(0)" data-toggle="text-collapse" class="btn btn-link btn-block"><i class="far fa-angle-up" aria-hidden="true"></i></a>');

        $btnToggle.click(function () {
            let $textCollapse = $(this).prev('.text-collapse');

            if ($textCollapse.data('collapsed')) {
                show($textCollapse);
            } else {
                hide($textCollapse);
            }
        });

        $element.after($btnToggle);

        if ($element.data('collapsed') === false) {
            show($element, true);
        } else {
            hide($element, true);
        }
    });
}

module.exports = {
    init, show, hide
};


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/text-collapse.js